import React from "react";
import { Controller } from "react-hook-form";
import { Grid, TextField, Typography, Paper } from "@mui/material";
import dayjs from "dayjs";

const Estimation = ({ tasks, control, currentYear }) => {
	const getMonthName = (monthNumber) => {
		return dayjs(new Date(2024, monthNumber - 1)).format("MMM");
	};

	return (
		<Paper elevation={3} sx={{ p: 3 }}>
			<Typography variant="h6" sx={{ mb: 3 }}>
				Task Estimation for {currentYear}
			</Typography>
			<Grid container spacing={2}>
				{tasks[0]?.months.map((month, index) => (
					<Grid item xs={3} key={index}>
						<Paper elevation={2} sx={{ p: 2 }}>
							<Typography sx={{ fontWeight: "bold" }} variant="subtitle1">
								{getMonthName(month.monthNumber)}
							</Typography>
							<Controller
								name={`months[${index}].monthNumber`}
								control={control}
								defaultValue={month.monthNumber || index + 1}
								render={({ field }) => <input {...field} type="hidden" value={field.value} />}
							/>
							<Controller
								name={`months[${index}].activeDays`}
								control={control}
								defaultValue={month.activeDays}
								render={({ field }) => (
									<TextField
										{...field}
										onChange={(e) => field.onChange(Number(e.target.value))}
										label="Active Days"
										type="number"
										variant="outlined"
										fullWidth
										margin="dense"
									/>
								)}
							/>
							<Controller
								name={`months[${index}].goals`}
								control={control}
								defaultValue={month.goals}
								render={({ field }) => (
									<TextField
										{...field}
										onChange={(e) => field.onChange(Number(e.target.value))}
										label="Goals"
										type="number"
										variant="outlined"
										fullWidth
										margin="dense"
									/>
								)}
							/>
						</Paper>
					</Grid>
				))}
			</Grid>
		</Paper>
	);
};

export default Estimation;
